import React from "react";
import { BrowserRouter, Routes, Route, Navigate, Outlet, useParams } from "react-router-dom";
import "@/App.css";

import { I18nProvider, SUPPORTED_LOCALES } from "@/i18n/I18nContext";
import ScrollToTop from "@/components/layout/ScrollToTop";
import SiteLayout from "@/components/layout/SiteLayout";
import Home from "@/pages/Home";
import LegalPage from "@/pages/LegalPage";
import ThankYou from "@/pages/ThankYou";
import NotFound from "@/pages/NotFound";

function LocalizedRoutes() {
  const { lang } = useParams();
  if (!SUPPORTED_LOCALES.includes((lang || "").toLowerCase())) {
    return <Navigate to="/mx" replace />;
  }
  return (
    <I18nProvider>
      <SiteLayout>
        <Outlet />
      </SiteLayout>
    </I18nProvider>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        {/* Default: redirect / to /mx */}
        <Route path="/" element={<Navigate to="/mx" replace />} />

        {/* Thank you page (Spanish only, no layout) */}
        <Route path="/thank_you" element={<ThankYou />} />

        {/* Localised routes */}
        <Route path="/:lang" element={<LocalizedRoutes />}>
          <Route index element={<Home />} />
          <Route path="privacy-policy" element={<LegalPage sectionKey="privacy" />} />
          <Route path="cookie-policy" element={<LegalPage sectionKey="cookies" />} />
          <Route path="terms" element={<LegalPage sectionKey="terms" />} />
          <Route path="*" element={<NotFound />} />
        </Route>

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/mx" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
